/*
 * File: d:\projects\AutoFiFront\src\Content\SynchroCar\SynchroCar.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 11th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 24th November 2023 09:08:22
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { useEffect, useState } from 'react';
import translator from 'MultiLanguage/TranslationWrapper';
import styles from "Content/SynchroCar/SynchroCar.module.css";
import Cookie from "Cookies/CookieWrapper";
import CookiePathResolver from 'Config/Cookies/CookiePathResolver';
import { useNavigate } from 'react-router-dom';
import CarService from 'Services/Cars/CarService';
import RouterPathResolver from 'Config/Router/RouterPathResolver';
import { handleLine, manageMyRespDisplay } from 'Utils/Response.utils';
import LoadingLines from 'Content/LoadingScreen/LoadingLines/LoadingLines';

function SynchroCar(_: any) {
    const navigate = useNavigate();
    const myCookie: string = Cookie.getCookie(CookiePathResolver.USER.TOKEN);
    const [carFile, setCarFile] = useState<File>();
    const [loading, setLoading] = useState(false);
    const [additionnalText, setAdditionnalText] = useState<JSX.Element[]>([]);
    const [lines, setLines] = useState<{key:string, value:string}[]>([]);

    useEffect(() => {
        if (myCookie === "" || myCookie === undefined)
            navigate(RouterPathResolver.routeCars.path);
    }, []);

    function setCar(e: any) {
        setCarFile(e.target.files[0]);
    }

    async function handleSubmit(e: any) {
        e.preventDefault();
        if (!carFile) return;
        setAdditionnalText([]);
        setLoading(true);

        CarService.sendCarFile(carFile, handleLine(setLines)).then(res => {
            const data = JSON.parse(res);
            if (data.error)
                throw data.myResp;
            manageMyRespDisplay(data.myResp, setAdditionnalText);
            setLoading(false);
        }).catch((e) => {
            if (e.message)
                manageMyRespDisplay(e.message, setAdditionnalText);
            else if (e["Erreur globale"])
                manageMyRespDisplay(e, setAdditionnalText);
            setLoading(false);
        })
    }

    return (
        <>
            {
                loading &&
                <div className={`${styles.spinnerHolder}`}>
                    <LoadingLines lines={lines} />
                </div>
            }
            {
                myCookie !== "" && myCookie !== undefined && (
                    <div className={`${styles.synchroCar}`}>
                        <div>
                            <h2 className={`${styles.title}`}>{translator.decode("synchro.title")}</h2>
                            <form>
                                <label htmlFor="carFile"> {translator.decode('synchro.carFile')} </label>
                                <br />
                                <input className={`${styles.inputFile}`} id='carFile' onChange={setCar} type="file" accept=".xlsx, .xls, .csv" />
                                <br />
                                <button className={`${styles.buttonSend}`} type="submit" onClick={handleSubmit}> {translator.decode("synchro.send")} </button>
                            </form>
                        </div>
                    </div>
                )
            }
            {!loading && (
                <div>
                    <div className={`${styles.showResult}`}>{additionnalText.map((mes) => mes)}</div>
                </div>
            )}
        </>
    );
}

export default SynchroCar;
